export default __webpack_public_path__ + "static/842-e51ed1282c438e8853cf7c5c386876d7.gif";